import { environment } from 'src/environments/environment';
import { UserRole } from '../shared/auth.roles';
const adminRoot = environment.adminRoot;

export interface IMenuItem {
  id?: string;
  icon?: string;
  label: string;
  to: string;
  newWindow?: boolean;
  subs?: IMenuItem[];
  roles?: UserRole[];
  userRoles?: string[]
}

const data: IMenuItem[] = [
  {
    icon: 'simple-icon-home',
    label: 'Home',
    to: `${adminRoot}/apphome/dashboard`,
    userRoles: ['Billing Manager', 'Payroll Manager', 'Ops Manager', 'admin', 'Supervisor', 'System Manager']
  },
  {
    icon: 'simple-icon-people',
    label: 'Admin',
    to: `${adminRoot}/admin`,
    subs: [
      {
        icon: 'simple-icon-pie-chart',
        label: 'Manage User(s)',
        to: `${adminRoot}/admin/manageusers`,
        userRoles: ['admin']
      }
      ,
      {
        icon: 'simple-icon-pie-chart',
        label: 'Add User',
        to: `${adminRoot}/admin/adduser`,
        userRoles: ['admin']
      },
      {
        icon: 'simple-icon-pie-chart',
        label: 'Manage Foreman(s)',
        to: `${adminRoot}/admin/foreman-settings`,
        userRoles: ['admin']
      },
      {
        icon: 'simple-icon-pie-chart',
        label: 'Manage Job Type(s)',
        to: `${adminRoot}/admin/manage-job-types`,
        userRoles: ['admin']
      }
    ],
    userRoles: ['admin']
  },
  {
    icon: 'simple-icon-list',
    label: 'Reports',
    to: `${adminRoot}/reports/dashboard`,
    userRoles: ['Billing Manager', 'Payroll Manager', 'Ops Manager', 'admin', 'System Manager']
  },
  
];
export default data;














